import React from 'react';
import { COLOR, PADDING, BORDER_RADIUS } from '@/utils/constants';
import styled from 'styled-components';
import SvgInline from '@latitude/svg-inline';

const StyledBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;
  background-color: ${({ background }) => background};
  padding: ${PADDING.P8};
  gap: ${PADDING.P8};
  border-radius: ${BORDER_RADIUS.BRAND}
`;

const ContentBox = styled.div``;

const StyledIcon = styled(SvgInline)`
  flex-shrink: 0;
  width: 24px;
  stroke: ${({ iconColor }) =>  iconColor};
  fill: ${({ iconColor }) =>  iconColor};
`;

/**
 *
 * @param icon - Icon name shared react
 * @param background - Hex color for bacground
 * @param iconColor - Hex color for icon
 * @param children - React node to be rendered inside the box
 * @returns Information Box component
 */
export const InfoBox = ({
  icon = 'info-block-outline',
  background = COLOR.BRAND_10,
  iconColor = COLOR.BLUE_DEEP,
  children
}) => {
  return (
    <StyledBox background={background}>
      <StyledIcon name={icon} iconColor={iconColor}  />
      <ContentBox>{children}</ContentBox>
    </StyledBox>
  );
};

export default InfoBox;
